<mat-accordion id="cancel-politics" class="info-accordion">
<div class="pb-2 pt-3 mb-0">
  <div class="subtitle_1 txt-darkGray font-14 pb-3">
    <h3 class="subtitle_1">
        {{ 'PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.TITLE' | translate }}
    </h3>
  </div>
    <!--  CANCEL POLICY  -->
    <div class="d-flex flex-wrap flex-row">
        <div class="d-flex flex-row align-items-center gap-8 w-100 pb-2">
            <lf-icon name="returnMoney" class="margin-check" width="18px" height="18px" fillColor="#1C69FF"></lf-icon>
            <span class="icon-booking-documents text_1">{{ "PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.FEES" | translate }}</span>
        </div>
        <div class="d-flex flex-row align-items-center gap-8 w-100 pb-2">
            <lf-icon name="money" class="margin-check" width="18px" height="18px" fillColor="#1C69FF"></lf-icon>
            <span class="icon-booking-documents text_1">
                    {{ "PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.REFUSED_BOOKING" | translate }}
                </span>
        </div>
    </div>
</div>

</mat-accordion>
